module.exports = "https://cdn.thelire.com/ins/resource/icoUsernameInstagram@3x.0f90fe7c00a95fcbba992c1797f8cfb5.png";